import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import QRGenerator from './components/QRGenerator';
import Home from './components/Home';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <h1>Matt's Portfolio</h1>
          <nav className="main-nav">
            <Link to="/">Home</Link>
            <Link to="/utils/QRGenerator">QR Generator</Link>
          </nav>
        </header>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/utils/QRGenerator" element={<QRGenerator />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;